import './Document.scss';

const data = {
    title: "Privacy Policy"
    ,body: "This Policy explains how Webtoon Today Inc. (the 'Company') treats information provided or collected through the Mate service (the 'Service'), including our mobile applications and website. As the controller of the information, we prioritize users' personal information security and transparently inform them about how we use and protect their data in the course of providing Korean language learning services through AI chatbots and real Korean tutors."
    ,nested: [
        {
            title: "Use of collected information"
            , prefix: "i"
            , body: "The Company uses the collected information of users for the following purposes:"
            , nested: [
                {title: "Member management and identification", prefix:'-'},
                {title: "Providing personalized language learning experiences", prefix:'-'},
                {title: "Matching users with appropriate Korean tutors", prefix:'-'},
                {title: "Analyzing and improving AI chatbot interactions", prefix:'-'},
                {title: "Processing payments for premium services", prefix:'-'},
                {title: "Tracking learning progress and generating reports", prefix:'-'},
                {title: "Improvement of existing services and development of new features", prefix:'-'},
                {title: "To comply with applicable laws or legal obligations", prefix: '-'},
            ]
        },
        {
            title: "Information to be collected"
            , prefix: "ii"
            , body: "Personal information items to be collected by the Company are as follows:"
            , nested: [
                {title: "Basic user information (name, email, profile photo)", prefix:'-'},
                {title: "Authentication data (encrypted SSO IDs from Google/Facebook)", prefix:'-'},
                {title: "Language learning preferences and proficiency levels", prefix:'-'},
                {title: "Chat logs with AI chatbots and tutors", prefix:'-'},
                {title: "Video call session recordings (with explicit consent)", prefix:'-'},
                {title: "Payment information for premium services", prefix:'-'},
                {title: "Learning progress and assessment data", prefix:'-'},
                {title: "Device information and access logs", prefix:'-'},
            ]
        },
        {
            title: "Protection of Video Call Data"
            , prefix: "iii"
            , body: "The Company takes special measures to protect video call sessions:"
            , nested: [
                {title: "All video calls are encrypted end-to-end", prefix:'-'},
                {title: "Recording of sessions requires explicit consent", prefix:'-'},
                {title: "Recorded sessions are stored securely and deleted after 30 days", prefix:'-'},
                {title: "Access to recordings is strictly limited to quality assurance purposes", prefix:'-'},
            ]
        },
        {
            title: "AI Data Processing"
            , prefix: "iv"
            , body: "For AI chatbot services, we process data as follows:"
            , nested: [
                {title: "Chat logs are used to improve AI responses", prefix:'-'},
                {title: "Personal information is removed from training data", prefix:'-'},
                {title: "AI models are regularly updated for accuracy", prefix:'-'},
                {title: "Users can request deletion of their chat history", prefix:'-'},
            ]
        },
        {
            title: " Usage of Google user data"
            , prefix: "v"
            , body: "We do collect and process Google user data:"
            , nested: [
                {title: "Using Google OAuth process", prefix:'-'},
                {title: "with limited range of user information(user id, name, email)", prefix:'-'},
                {title: "To distinguish users from others", prefix:'-'},
                {title: "To serve personalized curation/recommendation.", prefix:'-'},
                {title: "We do not share any of these information.", prefix:'-'},
            ]
        },
        {
            title: "Security"
            , prefix: "vi"
            , body: "The Company regard the security of personal information of uses as very important. The company constructs the following security measures to protect the users' personal information from any unauthorized access, release, use or modification"
            , nested: [
                {title: "Encryption of personal information", prefix: '-'},
                {title: "Countermeasures against hacking", prefix: '-'},
            ]
        },
        {
            title: "Cookies, Beacons and Similar Technologies"
            , prefix: "vii"
            , body: "The Company may collect collective and impersonal information through 'cookies'. The users have an option for cookie installation. So, they may either allow all cookies by setting option in web browser, make each cookie checked whenever it is saved, or refuses all cookies to be saved: Provided that, if the user rejects the installation of cookies, it may be difficult for that user to use the parts of services provided by the Company."
            , nested: [
            ]
        },
        {
            title: "Contact information"
            , prefix: "viii"
            , body: "Please use one of the following methods to contact the Company should you have any queries in respect to this policy or wish to update your information:"
            , nested: [
                {title: "privacy@webtoon.today"}
            ]
        },
    ]
};

const DrawData = (data: any, prefix: string, depth: number) => {
    return (
        <div style={{paddingLeft: depth * 20, fontSize: 120*Math.pow(0.9, depth)+'%' }}>
            <p>
                {data.prefix?`${data.prefix}`:''} {data.title || ""}
            </p>
            {data.body || ""}
            {data.nested?.map((row: any) => DrawData(row, prefix?`${prefix}.${data.prefix}`:data.prefix, depth+1))}
        </div>
    );
}

const PrivacyPolicyEn = () => {

    return (
        <div style={{textAlign:'left'}}>
            {DrawData(data, "", 1)}
        </div>
    );
}

export default PrivacyPolicyEn;